import BaseModelAPI from '../BaseModelAPI';

export default class RoleDetail extends BaseModelAPI {
	static entity = 'roledetail';
	static entityName = 'roledetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.roleId = '';
			this.role = {};
			this.functionInfoId = '';
			this.functionInfo = {};
			this.allowCreate = false;
			this.allowRead = false;
			this.allowUpdate = false;
			this.allowDelete = false;
			this.showInMenu = false;
			this.allowDownload = false;
			this.allowPrint = false;
			this.allowUpload = false;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}